"use strict";
var _a;
Object.defineProperty(exports, "__esModule", { value: true });
exports.LookUpRepository = void 0;
const tslib_1 = require("tslib");
const common_1 = require("@nestjs/common");
const typeorm_1 = require("@nestjs/typeorm");
const look_up_entity_1 = require("../../../../service-lib/src/lib/entities/look-up.entity");
const typeorm_2 = require("typeorm");
const constants_1 = require("../../../../service-lib/src/lib/constants");
const constants_2 = require("../../../../../../libs/service-lib/src/lib/constants");
let LookUpRepository = class LookUpRepository {
    constructor(lookUpRepository) {
        this.lookUpRepository = lookUpRepository;
    }
    /**
     * Retrieves all LookUps.
     */
    async getAllLookUps(search, sortBy = "id", sortOrder = "ASC", page = constants_1.DEFAULT_VALUES.PAGE, limit = constants_1.DEFAULT_VALUES.LIMIT) {
        const where = {};
        if (search !== undefined && search !== null && search !== "") {
            where.lookUpName = (0, typeorm_2.ILike)(`%${search}%`);
        }
        const result = await this.lookUpRepository.find({
            select: {
                id: true,
                lookUpName: true,
                lookUpKey: true,
                lookUpValueKey: true,
                lookUpValue: true,
                description: true,
            },
            ...(Object.keys(where).length > 0 && { where }),
            order: {
                [sortBy]: sortOrder,
            },
        });
        const offset = (page - 1) * limit;
        return { data: result.slice(offset, offset + limit) };
    }
    /**
     * Creates a new LookUp.
     */
    async createLookUp(lookUp) {
        const newLookUp = {
            ...lookUp,
            createdBy: constants_1.DEFAULT_VALUES.CREATED_BY,
            updatedBy: constants_1.DEFAULT_VALUES.UPDATED_BY,
        };
        const recorData = await this.lookUpRepository.save(newLookUp);
        const { createdBy, updatedBy, createdAt, updatedAt, ...filteredData } = recorData;
        return filteredData;
    }
    /**
     * Retrieves a single LookUp by ID.
     */
    async getLookUpById(id) {
        const lookUp = await this.lookUpRepository.findOne({
            select: {
                id: true,
                lookUpName: true,
                lookUpKey: true,
                lookUpValueKey: true,
                lookUpValue: true,
                description: true,
            },
            where: {
                id,
            },
        });
        if (!lookUp) {
            throw new Error(`LookUp with ID ${id} not found`);
        }
        return { data: lookUp };
    }
    /**
     * Updates a LookUp by ID.
     */
    async updateLookUpById(id, lookUp) {
        const existingLookUp = await this.getLookUpById(id);
        if (!existingLookUp) {
            throw new Error(`LookUp with ID ${id} not found`);
        }
        const updatedLookUp = {
            ...lookUp,
            updatedBy: constants_1.DEFAULT_VALUES.UPDATED_BY,
        };
        await this.lookUpRepository.update(id, updatedLookUp);
        return this.getLookUpById(id);
    }
    /**
     * Deletes a LookUp by ID
     */
    async deleteLookUpById(id) {
        const lookUp = await this.getLookUpById(id);
        if (!lookUp) {
            throw new Error(`LookUp with ID ${id} not found`);
        }
        await this.lookUpRepository.delete(id);
    }
    /**
     * fetches the lookup values by lookup name
     */
    async findByLookUpName(lookUpName) {
        const lookUps = await this.lookUpRepository.find({
            where: { lookUpName },
            order: { lookUpOrder: constants_2.DEFAULT_ASC_SORT_ORDER },
        });
        return lookUps.map((item) => ({
            id: item.id,
            lookUpValue: item.lookUpValue,
            lookUpKey: item.lookUpKey,
            lookUpName: item.lookUpName,
        }));
    }
    /**
     * fetches the lookup values by lookup name
     */
    async findByLookUpKey(lookUpKey) {
        const lookUps = await this.lookUpRepository.find({
            where: { lookUpKey },
        });
        return lookUps.map((item) => ({
            id: item.id,
            lookUpValue: item.lookUpValue,
            lookUpKey: item.lookUpKey,
            lookUpName: item.lookUpName,
        }));
    }
    /**
     * Retrieves distinct lookup names from the lookup_data table.
     */
    async getDistinctLookUpNames() {
        const result = await this.lookUpRepository
            .createQueryBuilder("lookup_data")
            .select("DISTINCT lookup_data.lookup_name", "lookup_name")
            .getRawMany();
        return result.map((row) => row.lookup_name);
    }
    /**
     * Retrieves LookUp records based on a list of lookup names.
     */
    async findByLookupNames(lookupNames) {
        try {
            // Validate lookupNames
            if (!Array.isArray(lookupNames) || lookupNames.length === 0) {
                throw new Error("lookupNames must be a non-empty array");
            }
            const lookUps = await this.lookUpRepository.find({
                where: { lookUpName: (0, typeorm_2.In)(lookupNames) },
                select: ["id", "lookUpValue", "lookUpName", "lookUpKey"],
                order: { lookUpName: "ASC" },
            });
            return lookUps.map((item) => ({
                id: item.id,
                lookUpValue: item.lookUpValue,
                lookUpName: item.lookUpName,
                lookUpKey: item.lookUpKey,
            }));
        }
        catch (error) {
            throw new Error(error instanceof Error
                ? error.message
                : "Failed to fetch LookUp records");
        }
    }
};
exports.LookUpRepository = LookUpRepository;
exports.LookUpRepository = LookUpRepository = tslib_1.__decorate([
    (0, common_1.Injectable)(),
    tslib_1.__param(0, (0, typeorm_1.InjectRepository)(look_up_entity_1.LookUp)),
    tslib_1.__metadata("design:paramtypes", [typeof (_a = typeof typeorm_2.Repository !== "undefined" && typeorm_2.Repository) === "function" ? _a : Object])
], LookUpRepository);
